"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateContainer = function (_React$Component) {
  (0, _inherits3.default)(TemplateContainer, _React$Component);

  function TemplateContainer() {
    (0, _classCallCheck3.default)(this, TemplateContainer);
    return (0, _possibleConstructorReturn3.default)(this, (TemplateContainer.__proto__ || (0, _getPrototypeOf2.default)(TemplateContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(TemplateContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.refs.template;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props;
      var item = _props.item;
      var itemSelected = _props.itemSelected;
      var anySelected = _props.anySelected;
      var dragHandle = _props.dragHandle;

      var Template = this.props.template;

      return _react2.default.createElement(Template, {
        ref: "template",
        item: item,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandle: dragHandle
      });
    }
  }]);
  return TemplateContainer;
}(_react2.default.Component);

TemplateContainer.propTypes = {
  item: _react.PropTypes.object.isRequired,
  template: _react.PropTypes.func.isRequired,
  itemSelected: _react.PropTypes.number.isRequired,
  anySelected: _react.PropTypes.number.isRequired,
  dragHandle: _react.PropTypes.func.isRequired
};
exports.default = TemplateContainer;
module.exports = exports["default"];
//# sourceMappingURL=data:application/json;base64,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


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-draggable-list/js/TemplateContainer.js
 ** module id = 371
 ** module chunks = 0
 **/